<template>
    <div class="contacts__map" id="contactMap"></div>
</template>

<script>
    export default {
        name: "contactsMap",
        methods: {
            initContactMap() {
                let contactMap;

                contactMap = new window.ymaps.Map("contactMap", {
                    center: [55.815028, 37.701214],
                    zoom: 15,
                });

                contactMap.controls.add('zoomControl');

                let placemark = new window.ymaps.Placemark([55.815028, 37.701214], {
                    balloonContent: 'AntiqueBay',
                    balloonCloseButton: true,
                    hideIconOnBalloonOpen: false
                });

                contactMap.geoObjects.add(placemark);
            },
        },
        mounted() {
            window.ymaps.ready(() => {
                this.initContactMap();
            });
        }
    }
</script>